import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "@mui/material/Button";
import Form from "react-bootstrap/Form";
import InfoModal from "../component/InfoModal";
import { useNavigate, Link } from "react-router-dom";
import Image from "react-bootstrap/Image";
import bgImage from "../assets/Images/auth/authbg.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useApplication } from "../hooks/UseApplication";
import { useToast } from "../Context/ToastContext";
import { CircularProgress } from "@mui/material";
import logirocLogo from "../assets/Images/logo/logirocblacktransparent.png";

const Login = () => {
    const navigate = useNavigate();
    const { login } = useApplication();
    const toaster = useToast();

    const [usernameValue, setUsernameValue] = useState("");
    const [passwordValue, setPasswordValue] = useState("");

    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const [passwordType, setPasswordType] = useState("password");

    const [modal, setModal] = useState({
        show: false,
        title: "",
        content: "",
        error: false,
    });

    /**
     * Load saved username/password.
     */
    useEffect(() => {
        const savedUsername = localStorage.getItem("username");
        const savedPassword = localStorage.getItem("password");
        const savedRememberMe = localStorage.getItem("rememberMe");

        if (
            savedRememberMe === "true" &&
            savedUsername &&
            savedPassword
        ) {
            setUsernameValue(savedUsername);
            setPasswordValue(savedPassword);
            setRememberMe(true);
        } else {
            setRememberMe(false);
        }
    }, []);

    /**
     * Save credentials only when "Se souvenir" is enabled.
     */
    const handleRememberMe = (checked) => {
        setRememberMe(checked);

        if (checked) {
            localStorage.setItem("username", usernameValue);
            localStorage.setItem("password", passwordValue);
            localStorage.setItem("rememberMe", "true");
        } else {
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            localStorage.setItem("rememberMe", "false");
        }
    };

    /**
     * Login
     */
    const loginSubmit = async (event) => {
        if (event) {
            event.preventDefault();
        }

        if (loading) {
            return;
        }

        setIsFormSubmitted(true);

        /**
         * Don't call the API if the form is invalid.
         */
        if (!usernameValue.trim() || !passwordValue) {
            return;
        }

        setLoading(true);

        try {
            const result = await login({
                username: usernameValue.trim(),
                password: passwordValue,
            });

            if (result?.error) {
                toaster.notifyError(
                    "Veuillez vérifier vos identifiants"
                );
                return;
            }

            /**
             * Save the remember-me preference.
             */
            if (rememberMe) {
                localStorage.setItem(
                    "username",
                    usernameValue
                );

                localStorage.setItem(
                    "password",
                    passwordValue
                );

                localStorage.setItem(
                    "rememberMe",
                    "true"
                );
            } else {
                localStorage.removeItem("username");
                localStorage.removeItem("password");

                localStorage.setItem(
                    "rememberMe",
                    "false"
                );
            }

            /**
             * Navigate only.
             *
             * IMPORTANT:
             * Do NOT call window.location.reload().
             */
            navigate("/map");
        } catch (error) {
            console.error("Login component error:", error);

            toaster.notifyError(
                "Une erreur est survenue lors de la connexion"
            );
        } finally {
            setLoading(false);
        }
    };

    /**
     * Password visibility.
     */
    const togglePassword = () => {
        setPasswordType((current) =>
            current === "password" ? "text" : "password"
        );
    };

    /**
     * Enter key.
     */
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            loginSubmit(event);
        }
    };

    /**
     * Modal.
     */
    const testCall = (arg) => {
        if (arg?.error) {
            setModal(arg);
        } else {
            setModal({
                show: false,
                content: "",
            });
        }
    };

    /**
     * Styles.
     */
    const InputedStyle = {
        height: "37px",
        backgroundColor: "#F3F7F9",
        border: "1px solid rgba(217, 217, 217, 0.35)",
        borderRadius: "5px",
    };

    const fontWeightTitle = {
        fontWeight: "600",
    };

    const connexionBtn = {
        height: "40px",
        background: "#1B208C",
        color: "#fff",
        border: "none",
    };

    const autoScreenheight = {
        height: "100vh",
    };

    const logocolor = {
        color: "#3F50B6",
    };

    const containerWd = {
        width: "774px",
    };

    return (
        <>
            <InfoModal
                show={modal?.show}
                onHide={testCall}
                data={modal}
            />

            <div
                className="d-flex align-items-center flex-wrap justify-content-center h-sm-auto w-100"
                style={autoScreenheight}
            >
                <div className="my-lg-0 my-md-0 my-sm-5 my-5">

                    <h2
                        className="text-center fs-1 mb-5 mx-5"
                        style={{
                            ...logocolor,
                            ...fontWeightTitle,
                        }}
                    >
                        <Image
                            style={{ maxWidth: "200px" }}
                            src={logirocLogo}
                        />
                    </h2>

                    <Container
                        className="container-fluid d-flex align-items-center flex-wrap justify-content-center w-xs-normal"
                        style={containerWd}
                    >
                        <Row
                            className="justify-content-center bg-white w-100 align-items-center px-0 flex-lg-nowrap flex-sm-wrap flex-wrap"
                            style={{
                                maxWidth: "774px",
                                borderRadius: "8px",
                                boxShadow:
                                    "1px 1px 10px 1px rgba(0, 0, 0, 0.03)",
                                height: "auto",
                            }}
                        >
                            <Col
                                className="ps-0 pe-lg-2 pe-sm-0 pe-0 col-lg col-md col-sm-12 col-12 h-lg-100 h-sm-50 h-md-440"
                            >
                                <Image
                                    className="fluid w-100 h-100 fit-cover"
                                    src={bgImage}
                                />
                            </Col>

                            <Col
                                className="col pe-4 py-lg-0 p-md-4 p-sm-5 p-4 my-3 mx-4 my-lg-0 my-sm-3 bg-white mx-lg-0 mx-sm-4 rounded"
                            >
                                <legend
                                    className="mb-3"
                                    style={fontWeightTitle}
                                >
                                    Connexion
                                </legend>

                                <form onSubmit={loginSubmit}>

                                    {/* USERNAME */}

                                    <Form.Group
                                        className="mb-4"
                                        controlId="formUserName"
                                    >
                                        <Form.Label
                                            style={fontWeightTitle}
                                        >
                                            Votre pseudo
                                        </Form.Label>

                                        <Form.Control
                                            className="input"
                                            type="text"
                                            placeholder="pseudo"
                                            required
                                            value={usernameValue}
                                            onChange={(e) =>
                                                setUsernameValue(
                                                    e.target.value
                                                )
                                            }
                                            style={InputedStyle}
                                        />

                                        {isFormSubmitted &&
                                            !usernameValue.trim() && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                    }}
                                                >
                                                    Le pseudo est obligatoire
                                                </span>
                                            )}
                                    </Form.Group>

                                    {/* PASSWORD */}

                                    <Form.Group
                                        className="mb-3"
                                        controlId="formPassword"
                                    >
                                        <Form.Label
                                            style={fontWeightTitle}
                                        >
                                            Mot de passe
                                        </Form.Label>

                                        <div
                                            className="input d-flex align-items-center ps-0"
                                            style={InputedStyle}
                                        >
                                            <Form.Control
                                                className="border-0 bg-transparent"
                                                placeholder="*********"
                                                required
                                                type={passwordType}
                                                value={passwordValue}
                                                onChange={(e) =>
                                                    setPasswordValue(
                                                        e.target.value
                                                    )
                                                }
                                                onKeyDown={
                                                    handleKeyDown
                                                }
                                                style={InputedStyle}
                                            />

                                            <button
                                                type="button"
                                                className="btn border-0 outline-0 bg-transparent"
                                                onClick={
                                                    togglePassword
                                                }
                                            >
                                                {passwordType ===
                                                "password" ? (
                                                    <VisibilityOffIcon />
                                                ) : (
                                                    <VisibilityIcon />
                                                )}
                                            </button>
                                        </div>

                                        {isFormSubmitted &&
                                            !passwordValue && (
                                                <span
                                                    style={{
                                                        color: "red",
                                                    }}
                                                >
                                                    Le mot de passe est
                                                    obligatoire
                                                </span>
                                            )}
                                    </Form.Group>

                                    {/* REMEMBER ME */}

                                    <div className="input-group mb-4 align-items-center">
                                        <input
                                            className="form-check-input mt-0 me-2 rounded-1"
                                            type="checkbox"
                                            checked={rememberMe}
                                            onChange={(e) =>
                                                handleRememberMe(
                                                    e.target.checked
                                                )
                                            }
                                        />

                                        <label className="fw-normal">
                                            Se souvenir
                                        </label>
                                    </div>

                                    {/* LOGIN */}

                                    <Button
                                        className="w-100 mb-3"
                                        type="submit"
                                        style={{
                                            ...connexionBtn,
                                            ...fontWeightTitle,
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <CircularProgress
                                                size={22}
                                                sx={{
                                                    color: "#fff",
                                                }}
                                            />
                                        ) : (
                                            "Se connecter"
                                        )}
                                    </Button>

                                    {/* REGISTER */}

                                    <div className="d-flex w-100 justify-content-center flex-wrap">
                                        <span>
                                            Pas encore de compte ?
                                        </span>

                                        <Link
                                            className="text-center text-black"
                                            to="/inscription/particulier"
                                        >
                                            <span className="d-block ms-2">
                                                S'inscrire ici
                                            </span>
                                        </Link>
                                    </div>

                                </form>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    );
};

export default Login;
